export default __webpack_public_path__ + "static/media/WhatsApp Image 2021-07-01 at 8.24.11 PM.aae3c644.jpeg";